import {
  setBrandPerformanceData,
  setBrandPerformanceLastRunData,
  setConversionLastTwoWeeksQueryData,
  setDimensionsMobile,
  setKeywordsQueryData,
  setLastTwoWeeksQueryData,
  setPreviousMonthQueryData,
  setTargetVsActualPR,
} from "../../../../features/businessLeaderDashboardSlice";
import { setDisplayErrorSnackBar } from "../../../../features/userSlice";
import { bizLeaderDashboardMobileService } from "../../../../services/mobileAPI/biz-dashboard.endpoints";
import store from "../../../../store";

async function getRecentPreviousMonthQueryInBizLeaderDashboardMobile({
  oauthTokenHeader,
  queryId,
  websiteSharedUids,
  type,
  dimension,
}: {
  oauthTokenHeader: string;
  queryId: string;
  websiteSharedUids: string[];
  type: string;
  dimension: string[];
}) {
  try {
    const response =
      await bizLeaderDashboardMobileService.getQueriesInBizLeaderDashboardMobile(
        {
          oauthTokenHeader,
          queryId,
          websiteSharedUids,
          type,
          dimension,
        },
      );
    if (!response.status || response.status !== 200) {
      throw new Error();
    }
    store.dispatch(setPreviousMonthQueryData(response?.data?.data || []));
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message:
          e?.parsedText ||
          "Failed to fetch previous month query data. Please try again later or Refresh the page.",
        type: "error",
      }),
    );
  }
}

async function getRecentLastTwoWeeksQueryInBizLeaderDashboardMobile({
  oauthTokenHeader,
  queryId,
  websiteSharedUids,
  type,
  dimension,
}: {
  oauthTokenHeader: string;
  queryId: string;
  websiteSharedUids: string[];
  type: string;
  dimension: string[];
}) {
  try {
    const response =
      await bizLeaderDashboardMobileService.getQueriesInBizLeaderDashboardMobile(
        {
          oauthTokenHeader,
          queryId,
          websiteSharedUids,
          type,
          dimension,
        },
      );
    if (!response.status || response.status !== 200) {
      throw new Error();
    }
    store.dispatch(setLastTwoWeeksQueryData(response?.data?.data || []));
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message:
          e?.parsedText ||
          "Failed to fetch last two weeks query data. Please try again later or Refresh the page.",
        type: "error",
      }),
    );
  }
}

async function getConversionLastTwoWeeksQueryInBizLeaderDashboardMobile({
  oauthTokenHeader,
  queryId,
  websiteSharedUids,
  type,
  dimension,
}: {
  oauthTokenHeader: string;
  queryId: string;
  websiteSharedUids: string[];
  type: string;
  dimension: string[];
}) {
  try {
    const response =
      await bizLeaderDashboardMobileService.getQueriesInBizLeaderDashboardMobile(
        {
          oauthTokenHeader,
          queryId,
          websiteSharedUids,
          type,
          dimension,
        },
      );
    if (!response.status || response.status !== 200) {
      throw new Error();
    }
    store.dispatch(
      setConversionLastTwoWeeksQueryData(response?.data?.data || []),
    );
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message:
          e?.parsedText ||
          "Failed to fetch last two weeks query data. Please try again later or Refresh the page.",
        type: "error",
      }),
    );
  }
}

async function getKeywordsQueryInBizLeaderDashboardMobile({
  oauthTokenHeader,
  queryId,
  websiteSharedUids,
  type,
  dimension,
  start_date,
  end_date,
}: {
  oauthTokenHeader: string;
  queryId: string;
  websiteSharedUids: string[];
  type: string;
  dimension: string[];
  start_date: string;
  end_date: string;
}) {
  try {
    const response = await bizLeaderDashboardMobileService.getQueriesInBizLeaderDashboardMobile({
      oauthTokenHeader,
      queryId,
      websiteSharedUids,
      type,
      dimension,
      start_date,
      end_date,
    });
    if (!response.status || response.status !== 200) {
      throw new Error();
    }
    store.dispatch(setKeywordsQueryData(response?.data?.data || []));
  } catch (e :any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message:
          e?.parsedText ||
          "Failed to fetch brand performance last run query data. Please try again later or Refresh the page.",
        type: "error",
      }),
    );
  }
}

async function getBrandPerformanceQueryInBizLeaderDashboardMobile({
  oauthTokenHeader,
  queryId,
  websiteSharedUids,
  type,
  dimension,
  start_date,
  end_date,
}: {
  oauthTokenHeader: string;
  queryId: string;
  websiteSharedUids: string[];
  type: string;
  dimension: string[];
  start_date: string;
  end_date: string;
}) {
  try {
    const response =
      await bizLeaderDashboardMobileService.getQueriesInBizLeaderDashboardMobile(
        {
          oauthTokenHeader,
          queryId,
          websiteSharedUids,
          type,
          dimension,
          start_date,
          end_date,
        },
      );
    if (!response.status || response.status !== 200) {
      throw new Error();
    }
    store.dispatch(setBrandPerformanceData(response?.data?.data || []));
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message:
          e?.parsedText ||
          "Failed to fetch brand performance query data. Please try again later or Refresh the page.",
        type: "error",
      }),
    );
  }
}

async function getBrandPerformanceLastRunQueryInBizLeaderDashboardMobile({
  oauthTokenHeader,
  queryId,
  websiteSharedUids,
  type,
  dimension,
}: {
  oauthTokenHeader: string;
  queryId: string;
  websiteSharedUids: string[];
  type: string;
  dimension: string[];
}) {
  try {
    const response =
      await bizLeaderDashboardMobileService.getQueriesInBizLeaderDashboardMobile(
        {
          oauthTokenHeader,
          queryId,
          websiteSharedUids,
          type,
          dimension,
        },
      );
    if (!response.status || response.status !== 200) {
      throw new Error();
    }
    store.dispatch(setBrandPerformanceLastRunData(response?.data?.data || []));
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message:
          e?.parsedText ||
          "Failed to fetch brand performance last run query data. Please try again later or Refresh the page.",
        type: "error",
      }),
    );
  }
}

async function getDimensionInBizLeaderDashboardMobile(oauthTokenHeader: any) {
  try {
    const response =
      await bizLeaderDashboardMobileService.getDimensionInBizLeaderDashboardMobile(
        oauthTokenHeader,
      );
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to get dimensions list");
    } else {
      store.dispatch(setDimensionsMobile(response?.data?.data));
    }
    return response;
  } catch (error: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: error?.parsedText || "Unknown error occurred",
        type: "error",
      }),
    );
  }
}

async function getTargetVsActualPR({
  oauthTokenHeader,
  queryId,
  startDate,
  endDate,
  websiteSharedUids,
  type,
  dimension,
}: {
  oauthTokenHeader: string;
  queryId: string;
  startDate: string;
  endDate: string;
  websiteSharedUids: string[];
  type: string;
  dimension: string[];
}) {
  try {
    const response = await bizLeaderDashboardMobileService.getTargetVsActualPR(
      oauthTokenHeader,
      queryId,
      startDate,
      endDate,
      type,
      websiteSharedUids,
      dimension,
    );
    if (!response.status || response.status !== 200) {
      throw new Error();
    }
    store.dispatch(
      setTargetVsActualPR(response?.data?.data?.query_output || []),
    );
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message:
          e?.parsedText ||
          "Failed to fetch previous month query data. Please try again later or Refresh the page.",
        type: "error",
      }),
    );
  }
}

export const buiDashboardEndPointLogicMobile = {
  getRecentPreviousMonthQueryInBizLeaderDashboardMobile,
  getRecentLastTwoWeeksQueryInBizLeaderDashboardMobile,
  getDimensionInBizLeaderDashboardMobile,
  getConversionLastTwoWeeksQueryInBizLeaderDashboardMobile,
  getKeywordsQueryInBizLeaderDashboardMobile,
  getBrandPerformanceQueryInBizLeaderDashboardMobile,
  getBrandPerformanceLastRunQueryInBizLeaderDashboardMobile,
  getTargetVsActualPR,
};
